export default __webpack_public_path__ + "static/media/Cryptosomm.be94aa14.jpeg";